import React, { useEffect, useState, useRef } from "react"
import DOMPurify from "isomorphic-dompurify"
import { getShortenedUrl } from "@/utils/helper"
import { favNoResultDataLayer } from "@/components/MyFavorites/v1/analytics/index"

const FavoriteNoResult = props => {
  const { authoredContent = {} } = props

  const [finalUrl, setFinalUrl] = useState("")
  const continueshoppingRef = useRef()

  useEffect(() => {
    if (authoredContent?.continueShoppingText) {
      getShortenedUrl(authoredContent?.continueShoppingText).then(res =>
        setFinalUrl(res)
      )
    }
  }, [authoredContent?.continueShoppingText])

  useEffect(() => {
    if (continueshoppingRef?.current) {
      continueshoppingRef?.current?.querySelectorAll("a").forEach(item => {
        item?.addEventListener("click", e => {
          favNoResultDataLayer(e)
        })
      })
    }
    return () => {
      continueshoppingRef?.current?.querySelectorAll("a").forEach(item => {
        item?.removeEventListener("click", e => {
          favNoResultDataLayer(e)
        })
      })
    }
  }, [finalUrl])

  return (
    <div className="favorite-no-results">
      <div className="container favorites__container">
        <h3 className="favorites__title">{authoredContent?.title}</h3>
      </div>

      <div
        className="no-result-description"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(authoredContent?.description),
        }}
      ></div>

      <div
        className="redirect-to-shopping"
        ref={continueshoppingRef}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(finalUrl),
        }}
      ></div>
    </div>
  )
}

export default FavoriteNoResult
